.boton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid transparent;
  border-radius: var(--radius-input);
  font-family: var(--font-body);
  font-weight: var(--peso-fuerte);
  cursor: pointer;
  transition:
    background-color var(--transition-fast),
    border-color var(--transition-fast),
    opacity var(--transition-fast),
    transform var(--transition-fast);
  white-space: nowrap;
  text-decoration: none;
}

.boton:active:not(:disabled) {
  transform: translateY(1px);
}

.boton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* --- Tamaños. Con puntero grueso todos alcanzan el área táctil mínima. --- */
.md {
  min-height: 2.5rem;
  padding: 0 1rem;
  font-size: var(--text-body);
}

.sm {
  min-height: 2rem;
  padding: 0 0.75rem;
  font-size: var(--text-caption);
}

.lg {
  min-height: 2.75rem;
  padding: 0 1.25rem;
  font-size: var(--text-body);
}

@media (pointer: coarse) {
  .md,
  .sm {
    min-height: var(--touch-target);
  }
}

/* --- Variantes --- */
.primario {
  background: var(--boton-primario-fondo);
  color: var(--boton-primario-texto);
}

.primario:hover:not(:disabled) {
  background: var(--boton-primario-fondo-hover);
}

.secundario {
  background: var(--card);
  color: var(--text-1);
  border-color: var(--border-strong);
}

.secundario:hover:not(:disabled) {
  background: var(--card-hover);
}

.fantasma {
  background: transparent;
  color: var(--text-2);
}

.fantasma:hover:not(:disabled) {
  background: var(--card-hover);
  color: var(--text-1);
}

.peligro {
  background: var(--status-danger);
  color: #fff;
}

.peligro:hover:not(:disabled) {
  filter: brightness(0.92);
}

.exito {
  background: var(--status-success);
  color: #fff;
}

.exito:hover:not(:disabled) {
  filter: brightness(0.92);
}

/* --- Modificadores --- */
.completo {
  width: 100%;
}

.soloIcono {
  padding: 0;
  aspect-ratio: 1;
}

.cargador {
  width: 0.9375rem;
  height: 0.9375rem;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: girar 700ms linear infinite;
}

@keyframes girar {
  to {
    transform: rotate(360deg);
  }
}

/*
 * Compacto en móvil: se queda el icono y se esconde el texto.
 *
 * `clip` en vez de `display: none` para que el texto siga estando presente
 * como nombre accesible del botón: escondido a la vista, no al lector de
 * pantalla.
 */
@media (max-width: 767px) {
  .compactoEnMovil {
    padding: 0;
    aspect-ratio: 1;
  }

  .compactoEnMovil .texto {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}
